import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './components/Header';
import Hero from './components/Hero';
import Servicios from './components/servicios';
import Equipos from './components/Equipos';
import Contacto from './components/Contacto';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import Testimonials from './components/Testimonials';
import AboutUs from './components/AboutUs';
import Partners from './components/Partners';
import Documentacion from './pages/Documentacion';

function App() {
  return (
    <Router>
      <meta name="description" content="Zamintech ofrece soluciones tecnológicas innovadoras y equipos de alta gama. Desarrollo de software, apps móviles y consultoría." />
      <meta name="keywords" content="Zamintech, desarrollo software, tecnología, venta de equipos, consultoría, innovación, pagina web, paginas web, Machala, El Oro, Santa Rosa, Arenillas, Huaquillas, desarrollo de software en Machala, crear aplicación móvil Ecuador, consultoría tecnológica para empresas en El Oro, venta de servidores para bananeras, soporte técnico para pymes Machala" />
      <meta name="author" content="Zamintech" />
      <link rel="canonical" href="https://www.zamintech.com/" />
      <Header />
      <Routes>
        {/* Página principal */}
        <Route path="/" element={
          <main > {/* Padding top para evitar que el header tape contenido */}
            <Hero />
            <Servicios />
            <Equipos />
            <Testimonials />
            <AboutUs />
            <Partners />
            <Contacto />
            <Footer />
            <WhatsAppButton />
            <ScrollToTop />
          </main>
        } />  
        {/* Página de documentación */}
        <Route path="/docs" element={<Documentacion />} />
      </ Routes>
    </ Router>
  );
}

export default App;
